import LanguageMenu from './LanguageMenu';

export { LanguageMenu };
export default LanguageMenu;
